/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Slider from "react-slick"
import moment from "moment"

import { useUpcomingEvents } from "../../../../hooks/useUpcomingEvents"
import { LinkField } from "../../linkField"

// eventDescription as Props

export const UpcomingEvents = () => {
  const events = useUpcomingEvents()

  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 1000,
    initialSlide: 1,
    draggable: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        },
      },
    ],
  }

  return (
    <div className="bg-bgmain">
      <div className="container flex items-center justify-center py-20 mx-auto">
        <Slider className="w-full customSlick event" {...settings}>
          {events.map(
            ({ eventDate, title, eventType, eventSignUpLink, uid }) => (
              <div
                className="flex flex-col items-center justify-center mx-auto my-4 text-center"
                key={uid}
              >
                <span className="px-4 py-1 text-xs uppercase border-2 rounded-full 2xl:text-sm text-secondary border-highlightColor">
                  {eventType[0]} {eventType[1] && <>+ {eventType[1]}</>}
                </span>
                <h4 className="mt-2 text-xl">
                  {moment(eventDate.start).format("D MMMM YYYY")}
                </h4>
                <p className="text-md">
                  {moment(eventDate.start).format("h:mm a")}-{moment(eventDate.end).format("h:mm a")}
                </p>
                <h1 className="max-w-md pt-4 mx-auto text-2xl font-semibold text-center">
                  {title}
                </h1>
                {/* <p className="pt-2 pb-10 mx-auto font-semibold text-center text-white uppercase ">
                  <div dangerouslySetInnerHTML={{ __html: eventDescription }} />
                </p> */}

                <LinkField
                  {...eventSignUpLink}
                  className="inline-block px-10 py-4 mt-4 font-semibold text-center text-white rounded bg-pink hover:bg-btnhover"
                >
                  Register
                </LinkField>
              </div>
            )
          )}
        </Slider>
      </div>
    </div>
  )
}
